import './utils/validation-popup';
import './utils/extensions';
import './utils/ajax';
import './utils/colors';
import './utils/common';
import './utils/localizable-string';
import './utils/convert-functions';
import './utils/cookie-helpers';
import './utils/dates';
import './utils/filter-prepare';
import './utils/html-query-url';
import './utils/markdown';
import './utils/rebind-data-source';
import './utils/toastr-utils';
import './utils/validation';
import './utils/work-days-renderer';
import './modules/back-multiselect';
import './modules/back-place-service/back-places-service';
import './modules/back-place-service/back-dadata-service';
import './modules/back-place-service/places-service-dispatcher';
import './modules/ai-assistant';
import './modules/dynamic-audit-history';
import './modules/static-requisite-history';
import './modules/expand-collapse-buttons';
import './modules/expand-collapse-buttons-treeview';
import './modules/filters';
import './modules/kanban';
import './modules/kendo';
import './modules/kendo-combobox';
import './modules/kendo-datepicker';
import './modules/kendo-editor';
import './modules/kendo-grid';
import './modules/kendo-grid-colors';
import './modules/kendo-multiselect';
import './modules/kendo-scheduler';
import './modules/kendo-textbox';
import './modules/kendo-tree-list';
import './modules/lazy-audio';
import './modules/local-comments';
import './modules/localization-description';
import './modules/model';
import './modules/pipeline';
import './modules/toastr';
import './modules/yandex-map';
import './modules/locale/get-locale-dict';

import { getCurrentCulture } from '@src/shared/lib/culture';

import { Gallery } from './modules/gallery';

window.Gallery = Gallery;

$.ajaxSetup({
    headers: {
        'X-Timezone': String(-(new Date().getTimezoneOffset() / 60)),
        'Accept-Language': getCurrentCulture()
    }
});

document.onkeydown = (e) => {
    const { code, ctrlKey, shiftKey, altKey } = e;
    const isOpenPopup = $('.dict-editor, .popup-content').is(':visible');
    const target = e.target;
    const isFocusInKendoTextarea = target instanceof Element && target.closest('.k-textarea');
    const filters = $('.filters ').get(0);
    const btToggleFilters = $('#btToggleFilters');

    // Для . и / используем code (физические клавиши)
    if (btToggleFilters.length === 1
        && filters
        && ctrlKey
        && !shiftKey
        && !altKey
        && (code === 'Period' || code === 'Slash')) {
        btToggleFilters.trigger('click');
    }

    if (filters && !isOpenPopup && !isFocusInKendoTextarea) {
        /**
         * 'Enter' keydown
         * */
        if (code === 'Enter') {
            e.preventDefault();
            $(':focus').trigger('blur');
            window.btFilter_onClick?.();
        }
    }

    // Ctrl + Key
    if (ctrlKey && !shiftKey && !altKey) {
        /**
         * 'S' keydown
         * */
        if (code === 'KeyS') {
            e.preventDefault();
            window.btSave_onClick?.();
        }
        /**
         * 'Q' keydown
         * */
        if (code === 'KeyQ') {
            window.wndTicket_createWindow?.();
        }
    }
};

$(() => {
    window.updateTimeZone();
    window.installToastr();
    window.loadModel();
    window.setFirst(true);
    void window.setFilters();

    const grid = window.findFirstGrid();

    if (grid) {
        window.setSettingsGrid(grid, window.isNeedFirstGridLoad);
    }

    window.datePeriodOnChange();

    if (localStorage.getItem(`${location.pathname} -showFilters`)
        || location.href.indexOf('showFilters') !== -1) {
        const btElem = $('#btToggleFilters');
        if (btElem.length === 1) {
            btElem[0].click();
        }
    }

    if (location.pathname.search(/\d+/g) === -1) {
        window.recollectFiltersOnSourceChange();
    }

    if (location.search && grid && window.btLoadAutosums_onClick) {
        grid.dataSource.one('change', () => {
            window.btLoadAutosums_onClick?.();
        });
    }

    window.floatingButtonsAutoTop();
    window.updateTimeZone();
    window.initKendoGrid();
    window.setProperIframeResize();
    window.bindResizeHeightMultiSelect();
    window.setControlsSettings();
    window.setColorsTdYesNo();
    window.headerCheckbox_bindCheckEvent();
    window.initKendoEditorVerticalOnlyResize();
});

$(window).on('resize', () => {
    window.floatingButtonsAutoTop();
});

(() => {
    const nowTime = Date.now();
    const url = '/LaborCalendar/GetNotWorking';
    const timeLife = localStorage.getItem('notWorkingDaysCalendarTimeLife') ?? '0';

    try {
        const parsedTime = JSON.parse(timeLife);

        if (nowTime - parsedTime > 4800000) {
            localStorage.setItem('notWorkingDaysCalendarTimeLife', nowTime.toString());
            window.ajaxGet(url, null, (response: string[]) => {
                localStorage.setItem('notWorkingDaysCalendar', JSON.stringify(response.map(window.formatDateForDataPicker)));
            });
        }
    }
    catch (error) {
        console.error('Ошибка при парсинге времени жизни', error);
    }
})();